import React, { useState, useEffect, useRef, useCallback } from "react";
import { Box, Typography, Paper, Grid, IconButton } from "@mui/material";
import * as Mui from "@mui/material";
import { customAPI } from "services/utils/CustomAPI";
import GroupRemoveIcon from "@mui/icons-material/GroupRemove";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { CustomFullWidthButton } from "components/CustomComponents/CustomButton";
import { defaultAllSelection } from "services/constants";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { DoubleArrow, DateRange } from "@mui/icons-material";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { eligibleEmployee } from "pages/PayRoll/PayRollHeaders";
import { ConfirmationDialog } from "components/CustomComponents/ConfirmationDialog";
import { atleastOneCharacterWithSpace } from "services/constants/patterns";
import { CustomTextBox } from "components/CustomComponents";
import AddIcon from "@mui/icons-material/Add";
import { fourDigitTwoDecimalPattern } from "services/constants/patterns";
import { minimum3Characters } from "services/constants/ErrorMessages";
import moment from "moment";
import {
  doubleArrowStyle,
  themes,
  childBoxStyleWithColor,
  infoStyle,
} from "services/constants";
import { scrollTop, stickyHeader, tableRowSize } from "services/constants";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { CustomAutoComplete } from "components/CustomComponents";
import { useFetch } from "services/hooks/useFetch";
import { customGetAPI } from "services/utils/CustomAPI";
import { showToast } from "services/utils/Status";
import dayjs from "dayjs";
export const CreatePayCycleIncentive = ({
  onClose,
  reCallApi,
  editScreen,
  selectedRecord,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      incentiveName: "",
      cycleName: "",
      start_date: moment(),
      end_date: moment(),
      template: "Incentive1",
      payrun: "",
    },
  });
  const { domain, topbarCompanyId } = useSelector(
    (state) => state.tokenReducer,
  );
  const [eligibleUserDetails, setEligibleUserDetails] = useState([]);
  const [payscheduleDetails, setPayscheduleDetails] = useState([]);
  const { result: incentiveData } = useFetch(
    `${domain}hrzone/incentive/incentive-template/`,
  );
  const [eligiblityUser, setEligiblityUser] = useState(null);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [dataPrefill, setDataPrefill] = useState(true);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [tab, setTab] = useState("Qualified");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [incentiveDetails, setIncentiveDetails] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const updateExisitngData = () => {
      setValue("incentiveName", selectedRecord?.incentive_template_name || "");
      setValue("incentive_id", selectedRecord?.incentive_template_id ?? null);
      setValue("cycleName", selectedRecord?.payroll_schedule_name || "");
      setValue("cycleName_id", selectedRecord?.payroll_schedule_id ?? null);
      setValue("start_date", dayjs(selectedRecord?.start_date, "DD-MM-YYYY"));
      setValue("end_date", dayjs(selectedRecord?.end_date, "DD-MM-YYYY"));
      const formattedData = {
        ...selectedRecord,
        qualified_users: selectedRecord?.qualified_users || [],
        not_qualified_users: selectedRecord?.not_qualified_users || [],
        eligible_users: selectedRecord?.qualified_users || [], // or your logic
      };

      setEligibleUserDetails(formattedData);
      let currentIncentiveTemp = incentiveData.find((data) => {
        return data?.name === selectedRecord?.incentive_template_name;
      });
      setIncentiveDetails(currentIncentiveTemp);
      setDataPrefill(false);
    };
    if (dataPrefill && editScreen && incentiveData?.length !== 0) {
      updateExisitngData();
    }
  }, [dataPrefill, editScreen, incentiveData, selectedRecord, setValue]);

  useEffect(() => {
    const getPaySchedule = async () => {
      const res = await customGetAPI(
        `${domain}payroll/operations/payrollprocessing/payrollruncycle/list-payschedules/?company_id=${topbarCompanyId}`,
      );
      if (res.ok) {
        setPayscheduleDetails(res?.responseDetails);
      }
    };
    getPaySchedule();
  }, [domain, topbarCompanyId]);

  const label =
    watch("start_date").format("DD/MM/YYYY") +
    " - " +
    watch("end_date").format("DD/MM/YYYY");

  const handleCallback = (start, end) => {
    setValue("start_date", start);
    setValue("end_date", end);
  };

  const handleIncentive = (_, data) => {
    setIncentiveDetails(data);
    setValue("incentiveName", data?.label || "");
    setValue("incentive_id", data?.id ?? null);
  };

  const handleCycleDetails = (_, data) => {
    setValue("cycleName", data?.label || "");
    setValue("cycleName_id", data?.id ?? null);
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return (
      d.getFullYear() +
      "-" +
      String(d.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(d.getDate()).padStart(2, "0")
    );
  };

  const calculate_incentive_details = async (data) => {
    const startDate = watch("start_date");
    const endDate = watch("end_date");
    const incentiveId = watch("incentive_id");
    const payrollId = watch("cycleName_id");
    // Check required values
    if (!startDate || !endDate || !incentiveId || !payrollId) {
      return; // ignore if any value is missing
    }
    const res = await customGetAPI(
      `${domain}payroll/incentive/calculate-incentive/?start_date=${formatDate(startDate)}&end_date=${formatDate(endDate)}&incentive_template_id=${incentiveId}&payroll_schedule_id=${payrollId}&company_id=${topbarCompanyId}`,
    );
    if (res?.ok) {
      setEligibleUserDetails(res?.responseDetails);
      showToast("success", "Eligible details calculated.");
    }
  };

  const getTableData = () => {
    if (!eligibleUserDetails) return [];

    switch (tab) {
      case "Qualified":
        return eligibleUserDetails.qualified_users;

      case "Not Qualified":
        return eligibleUserDetails.not_qualified_users;

      case "Eligible":
        return eligibleUserDetails.eligible_users;

      default:
        return [];
    }
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const handleFilteredDataChange = useCallback(
    (data) => {
      setFilteredRecords(data);
      if (page * rowsPerPage >= data.length) {
        setPage(0);
      }
    },
    [page, rowsPerPage],
  );

  const save_incentive_details = async (status) => {
    const startDate = watch("start_date");
    const endDate = watch("end_date");
    const incentiveId = watch("incentive_id");
    const payrollId = watch("cycleName_id");
    const payload = {
      ...eligibleUserDetails,
      start_date: formatDate(startDate),
      end_date: formatDate(endDate),
      incentive_template_id: incentiveId,
      payroll_schedule_id: payrollId,
      status: status,
      total_incentive_amount: Number(
        eligibleUserDetails?.total_incentive_amount ?? 0.0,
      ).toFixed(2),
    };
    let URL = editScreen
      ? `${domain}payroll/incentive/incentive-crud/${selectedRecord?.id}/&company_id=${topbarCompanyId}`
      : `${domain}payroll/incentive/incentive-crud/?company_id=${topbarCompanyId}`;
    const response = await customAPI(URL, editScreen ? "PUT" : "POST", payload);
    if (response.ok) {
      reCallApi(true);
      onClose();
    }
  };

  const handleCancelClose = () => {
    setShowConfirmationDialog(false);
  };

  const handleRejectedReason = (event) => {
    if (event.target.value.length <= 1024) {
      setValue("remove_reason", event.target.value);
    }
  };

  const handleRemoveUser = async (data) => {
    if (tab === "Qualified") {
      setEligibleUserDetails((prev) => {
        const userToMove = prev.qualified_users.find(
          (u) => u.user_id === eligiblityUser?.user_id,
        );
        if (!userToMove) return prev;
        const updatedUser = {
          ...userToMove,
          amount: data?.remove_reason || "",
        };
        return {
          ...prev,
          qualified_users: prev.qualified_users.filter(
            (u) => u.user_id !== eligiblityUser?.user_id,
          ),
          not_qualified_users: [...prev.not_qualified_users, updatedUser],
        };
      });
    } else {
      setEligibleUserDetails((prev) => {
        const userToMove = prev.not_qualified_users.find(
          (u) => u.user_id === eligiblityUser?.user_id,
        );
        if (!userToMove) return prev;
        const updatedUser = {
          ...userToMove,
          amount: data?.remove_reason || "",
          total_amount: data?.total_amount ?? 0,
        };
        return {
          ...prev,
          not_qualified_users: prev.not_qualified_users.filter(
            (u) => u.user_id !== eligiblityUser?.user_id,
          ),
          qualified_users: [...prev.qualified_users, updatedUser],
        };
      });
    }
    setValue("remove_reason", "");
    handleCancelClose(false);
    showToast("success", "User added / removed.");
  };

  const handleIncenitveAmount = (event) => {
    if (
      fourDigitTwoDecimalPattern.test(event.target.value) ||
      event.target.value === ""
    ) {
      setValue("total_amount", event.target.value ?? "");
    }
  };

  return (
    <Box sx={{ height: "100%" }}>
      {/* HEADER */}
      <form onSubmit={handleSubmit(calculate_incentive_details)}>
        <Paper
          elevation={0}
          sx={{
            borderBottom: `1px solid ${themes?.miliedLightGray}`,
            borderRadius: 0,
          }}
        >
          <Box sx={childBoxStyleWithColor}>
            <Box sx={{ ml: 1 }}>
              <IconButton onClick={onClose} sx={doubleArrowStyle}>
                <DoubleArrow />
              </IconButton>
            </Box>

            <Box sx={{ ml: 2.2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Incentive
              </Typography>
              <Typography {...infoStyle}>
                Create and manage incentive rules for employee performance
              </Typography>
            </Box>
          </Box>
        </Paper>
        <Mui.Box
          sx={{
            display: "flex",
            gap: 2,
            width: "100%",
          }}
        >
          {/* DATE RANGE */}
          <Mui.Box sx={{ padding: 1, flex: 1 }}>
            <Mui.Typography sx={{ fontWeight: 600 }}>Date Range</Mui.Typography>
            <Typography
              {...infoStyle}
              sx={{
                ...infoStyle.sx,
                mb: 1.5,
              }}
            >
              Select the period which this incentive is valid
            </Typography>
            <DateRangePicker
              initialSettings={{
                startDate: watch("start_date").toDate(),
                endDate: watch("end_date").toDate(),
                applyClass: "custom-apply-btn",
                cancelClass: "custom-cancel-btn",
                locale: { format: "DD/MM/YYYY" },
              }}
              onCallback={handleCallback}
            >
              <Mui.TextField
                id="reportrange"
                placeholder="Select a date range"
                value={label}
                size="small"
                fullWidth
                InputProps={{
                  readOnly: true,
                  notched: false,
                  endAdornment: (
                    <Mui.InputAdornment position="end">
                      <Mui.IconButton>
                        <DateRange />
                      </Mui.IconButton>
                    </Mui.InputAdornment>
                  ),
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: 35,
                    backgroundColor: "#fff", // same as MUI small input
                  },
                  "& .MuiOutlinedInput-notchedOutline legend": {
                    display: "none",
                  },
                }}
              />
            </DateRangePicker>
          </Mui.Box>

          {/* INCENTIVE TEMPLATE */}
          <Mui.Box sx={{ padding: 1, flex: 1 }}>
            <Mui.Typography sx={{ fontWeight: 600 }}>
              Payrun Cycle
            </Mui.Typography>
            <Typography
              {...infoStyle}
              sx={{
                ...infoStyle.sx,
                mb: 1,
              }}
            >
              Choose when the incentive should be paid
            </Typography>
            <CustomAutoComplete
              dataList={payscheduleDetails?.map((obj) => ({
                ...obj,
                label: obj.name,
              }))}
              selectedValue={watch("cycleName")}
              rules={{
                ...register("cycleName", {
                  required: "Cycle name is required",
                }),
              }}
              updateDataFunction={handleCycleDetails}
              placeHolder="Select the payrun cycle name"
              errorMessage={errors?.cycleName?.message ?? ""}
              textBoxError={!!errors?.cycleName}
            />
          </Mui.Box>
        </Mui.Box>

        <Mui.Box sx={{ padding: 1, width: "100%" }}>
          <Mui.Typography sx={{ fontWeight: 600 }}>
            Incentive Template
          </Mui.Typography>

          <Typography
            {...infoStyle}
            sx={{
              ...infoStyle.sx,
              mb: 1,
            }}
          >
            Select a template name to identify this incentive plan
          </Typography>

          <CustomAutoComplete
            dataList={incentiveData?.map((obj) => ({
              ...obj,
              label: obj.name,
            }))}
            selectedValue={watch("incentiveName")}
            rules={{
              ...register("incentiveName", {
                required: "Incentive name is required",
              }),
            }}
            updateDataFunction={handleIncentive}
            placeHolder="Select the department name"
            errorMessage={errors?.incentiveName?.message ?? ""}
            textBoxError={!!errors?.incentiveName}
          />
        </Mui.Box>

        {/* FORM */}
        {watch("incentiveName") && (
          <Box p={2}>
            {/* INCENTIVE CARD */}
            <Paper sx={{ p: 2, mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography>Incentive Type:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography color="green">
                    {incentiveDetails?.incentive_type ?? "N/A"}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography>Eligibility Logic:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography color="green">
                    {incentiveDetails?.eligibility_logic ?? "N/A"}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography>Eligibility:</Typography>
                </Grid>
                <Grid item xs={6}>
                  {Object.entries(
                    incentiveDetails?.eligibility_summary || {},
                  ).map(([key, values]) => (
                    <Box key={key} display="flex" gap={1}>
                      <Typography sx={{ fontWeight: 500 }}>{key}:</Typography>
                      <Typography color="text.secondary">
                        {values.map((v) => v.name).join(", ")}
                      </Typography>
                    </Box>
                  ))}
                </Grid>

                <Grid item xs={6}>
                  <Typography>Qualification:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>
                    {incentiveDetails?.incentive_type} ≥{" "}
                    {incentiveDetails?.qualification_value}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography>Payout Type:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography color="green">
                    {incentiveDetails?.payout_value} /{" "}
                    {incentiveDetails?.payout_basis}
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <Typography>Maximum Cap:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography>{incentiveDetails?.maximum_cap}</Typography>
                </Grid>
              </Grid>
            </Paper>

            {/* BUTTON */}
            <Box mt={2}>
              <CustomFullWidthButton
                customWidth={650}
                actionName="Calculate Incentive"
                typeName="submit"
                // disableAction={
                //   watch("cycleName") && watch("incentiveName") ? false : true
                // }
              />
            </Box>

            {/* TABS */}
            <Box
              mt={3}
              sx={{
                backgroundColor: "#f5f5fd",
                paddingLeft: 1,
                paddingRight: 1,
              }}
            >
              <Typography variant="h6">Qualified Employee Preview</Typography>

              {/* Custom Tabs */}
              <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                {["Qualified", "Not Qualified", "Eligible"].map((label) => (
                  <Box
                    key={label}
                    sx={{
                      padding: "10px 20px",
                      backgroundColor: tab === label ? "white" : "transparent",
                      color: tab === label ? "primary.main" : "text.secondary",
                      fontWeight: 600,
                      cursor: "pointer",
                      borderTopLeftRadius: "8px",
                      borderTopRightRadius: "8px",
                      marginBottom: "-1px",
                      border: "1px solid",
                      borderColor: tab === label ? "grey.300" : "transparent",
                      "&:hover": {
                        backgroundColor: tab === label ? "white" : "grey.100",
                      },
                    }}
                    onClick={() => setTab(label)}
                  >
                    {label}
                  </Box>
                ))}
              </Box>

              {/* TABLE */}
              <Paper sx={{ mt: 0 }}>
                <CustomFilter
                  title={`${tab} Employees`}
                  filterHeaders={eligibleEmployee}
                  data={getTableData()}
                  filteredData={filteredRecords}
                  onFilteredDataChange={handleFilteredDataChange}
                  screenAccess={true}
                  viewFilter={false}
                />{" "}
                <Mui.TableContainer
                  ref={containerRef}
                  sx={{
                    maxHeight: "60vh",
                    overflow: "auto",
                  }}
                >
                  <Mui.Table size="small" sx={{ minWidth: 450 }}>
                    <Mui.TableHead sx={stickyHeader}>
                      <Mui.TableRow sx={tableRowSize}>
                        <Mui.TableCell>Employee Id</Mui.TableCell>
                        <Mui.TableCell>Name</Mui.TableCell>
                        <Mui.TableCell>Dept</Mui.TableCell>
                        <Mui.TableCell>Designation</Mui.TableCell>
                        <Mui.TableCell></Mui.TableCell>
                      </Mui.TableRow>
                    </Mui.TableHead>
                    <Mui.TableBody>
                      {filteredRecords?.map((row) => (
                        <Mui.TableRow key={row.id}>
                          <Mui.TableCell>{row.employee_id}</Mui.TableCell>
                          <Mui.TableCell>
                            <Mui.Stack direction="Row">
                              <Mui.Avatar
                                sx={{
                                  width: 25,
                                  height: 25,
                                }}
                                alt="Remy Sharp"
                                src={row.image_url}
                              />
                              <Mui.Typography
                                sx={{
                                  paddingLeft: 1,
                                }}
                              >
                                {row.name}
                              </Mui.Typography>
                            </Mui.Stack>
                          </Mui.TableCell>
                          <Mui.TableCell>{row.department}</Mui.TableCell>
                          <Mui.TableCell>
                            {row.designation || "-"}
                          </Mui.TableCell>
                          <Mui.TableCell>
                            {tab === "Qualified" ? (
                              <GroupRemoveIcon
                                onClick={() => {
                                  setValue("remove_reason", "");
                                  setValue("total_amount", defaultAllSelection);
                                  setEligiblityUser(row);
                                  setShowConfirmationDialog(true);
                                }}
                              />
                            ) : (
                              <AddIcon
                                onClick={() => {
                                  setValue("remove_reason", "");
                                  setValue("total_amount", 0);
                                  setEligiblityUser(row);
                                  setShowConfirmationDialog(true);
                                }}
                              />
                            )}
                          </Mui.TableCell>
                        </Mui.TableRow>
                      ))}

                      {filteredRecords?.length === 0 && (
                        <Mui.TableRow>
                          <Mui.TableCell colSpan={4} align="center">
                            No Data Available
                          </Mui.TableCell>
                        </Mui.TableRow>
                      )}
                    </Mui.TableBody>
                  </Mui.Table>
                </Mui.TableContainer>{" "}
                {filteredRecords.length > 25 && (
                  <Mui.TablePagination
                    component="div"
                    rowsPerPageOptions={[25, 50, 75, 100]}
                    count={filteredRecords.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                )}{" "}
              </Paper>
            </Box>

            {/* FOOTER BUTTONS */}
            <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
              <CustomButton
                actionFuntion={() => {
                  save_incentive_details("Submitted");
                }}
                actionName="Submit"
                typeName="button"
              />
              <CustomButton
                actionFuntion={() => {
                  save_incentive_details("Inprogress");
                }}
                actionName="Save"
                typeName="button"
              />
            </Box>
          </Box>
        )}
      </form>
      <ConfirmationDialog
        open={showConfirmationDialog}
        onClose={handleCancelClose}
        onConfirm={handleSubmit(handleRemoveUser)}
        title={tab === "Qualified" ? "Remove Reason" : "Add Reason"}
        message={
          tab === "Qualified"
            ? "Remove the incentive user "
            : "Add the incentive user "
        }
        confirmText={tab === "Qualified" ? "Remove" : "Add"}
        cancelText="Cancel"
        showChildren={true}
      >
        {tab !== "Qualified" ? (
          <Box>
            <Typography sx={{ fontWeight: 600 }}>Amount</Typography>
            <Typography {...infoStyle}>Enter the Incentive amount</Typography>
            <CustomTextBox
              selectedValue={watch("total_amount")}
              rules={{
                ...register("total_amount", {
                  required: false,
                  validate: {
                    minLengthNoSpaces: (value) => {
                      if (
                        !watch("total_amount") ||
                        watch("total_amount") === "0"
                      ) {
                        return "incentive amount is required";
                      } else {
                        return true;
                      }
                    },
                  },
                }),
              }}
              updateDataFunction={handleIncenitveAmount}
              placeHolder="Enter the incentive amount"
              errorMessage={
                errors?.total_amount?.message
                  ? errors?.total_amount?.message
                  : ""
              }
              textBoxError={errors.total_amount ? true : false}
            />
          </Box>
        ) : null}
        <Box>
          <Typography sx={{ fontWeight: 600 }}>Reason</Typography>
          <Typography {...infoStyle}>
            Enter the reason for this {tab === "Qualified" ? "remove" : "add"}
          </Typography>
          <CustomTextBox
            type="multiline"
            rules={{
              ...register("remove_reason", {
                required: showConfirmationDialog
                  ? tab === "Qualified"
                    ? "Remove reason is required"
                    : "Add reason is required"
                  : false,
                validate: {
                  minLengthNoSpaces: (value) => {
                    if (showConfirmationDialog) {
                      if (value?.trim().length < 3 && value !== "") {
                        return minimum3Characters;
                      } else if (value?.trim().length > 255 && value !== "") {
                        return "Maximum length is 255 characters";
                      } else {
                        return true;
                      }
                    }
                  },
                  atleastOneCharacterWithSpaceReg: (value) => {
                    if (
                      atleastOneCharacterWithSpace.test(value) ||
                      value === "" ||
                      !showConfirmationDialog
                    ) {
                      return true;
                    } else {
                      return "Atleast one alphabet required";
                    }
                  },
                },
              }),
            }}
            selectedValue={watch("remove_reason")}
            updateDataFunction={handleRejectedReason}
            placeHolder={
              tab === "Qualified"
                ? "Provide a reason for remove"
                : "Provide a reason for add"
            }
            errorMessage={
              errors?.remove_reason?.message
                ? errors?.remove_reason?.message
                : ""
            }
            textBoxError={errors?.remove_reason ? true : false}
          />
        </Box>
      </ConfirmationDialog>
    </Box>
  );
};
